import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';
import { CheckCircle, Circle, ArrowRight } from 'lucide-react';

const TransactionTimeline = ({ data }) => {
  const { t } = useTranslation();
  
  return (
    <div className="max-w-4xl mx-auto">
      <div className="relative">
        {/* Timeline Line */}
        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 top-0 bottom-0 w-1 bg-gradient-to-b from-[#C9A961] to-[#2C5F66]"></div>

        {/* Timeline Items */}
        <div className="space-y-8">
          {data.map((item, idx) => (
            <div key={idx} className={`relative flex items-center ${
              idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
            } flex-col`}>
              {/* Content Card */}
              <div className={`w-full md:w-5/12 ${
                idx % 2 === 0 ? 'md:text-right md:pr-8' : 'md:text-left md:pl-8'
              }`}>
                <Card className="border-slate-200 hover:shadow-xl transition-all duration-300 hover:border-[#C9A961]">
                  <CardContent className="p-6">
                    <div className={`flex items-center space-x-3 mb-3 ${
                      idx % 2 === 0 ? 'md:flex-row-reverse md:space-x-reverse' : ''
                    }`}>
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0A2540] to-[#2C5F66] flex items-center justify-center flex-shrink-0">
                        <span className="text-white font-bold text-lg">{item.step}</span>
                      </div>
                      <h3 className="text-xl font-bold text-[#0A2540]">{item.title}</h3>
                    </div>
                    <p className="text-slate-600 mb-3 leading-relaxed">{item.description}</p>
                    <div className="inline-flex items-center space-x-2 bg-[#C9A961]/10 border border-[#C9A961]/30 rounded-full px-4 py-1">
                      <span className="text-sm font-medium text-[#0A2540]">{item.duration}</span>
                    </div>
                  </CardContent>
                </Card>
              </div>

              {/* Center Circle */}
              <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full bg-white border-4 border-[#C9A961] items-center justify-center z-10 shadow-lg">
                {idx < data.length - 1 ? (
                  <Circle className="w-6 h-6 text-[#C9A961] fill-current" />
                ) : (
                  <CheckCircle className="w-6 h-6 text-[#2C5F66] fill-current" />
                )}
              </div>

              {/* Mobile Circle */}
              <div className="md:hidden flex w-12 h-12 rounded-full bg-white border-4 border-[#C9A961] items-center justify-center mb-4 shadow-lg">
                <span className="text-[#0A2540] font-bold">{item.step}</span>
              </div>

              {/* Empty space for alternating layout */}
              <div className="hidden md:block w-5/12"></div>
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#0A2540] to-[#2C5F66] text-white px-8 py-4 rounded-full shadow-xl">
            <CheckCircle className="w-6 h-6" />
            <span className="font-semibold text-lg">{t('timeline.ctaText')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionTimeline;